module.exports = __webpack_public_path__ + "img/new_index_cases11.f5317cb8.png";